module.exports = __webpack_public_path__ + "img/by.a0fd9e15.svg";